import React from "react";

import * as S from "./MenuItem.styles";
import Icon from "../../../atoms/Icon/Icon.component";
import { Paragraph } from "../../../atoms/Typography/Typography.component";
import LinkWrapper from "../../../atoms/LinkWrapper/LinkWrapper.component";
import { SpacerBase } from "../../../atoms/GridSystem";

interface MenuItem {
  id?: string;
  title?: string;
  label?: string;
  description?: string;
  href?: string;
  target?: string;
  [key: string]: any;
}

const MenuItem = ({ label, title, description, href, target = '_self', handleClick }: MenuItem) => {
  return (
    <LinkWrapper href={href}>
      <S.MenuItem 
        as={typeof handleClick === 'function' ? 'button' : 'a'} 
        onClick={() => {
          typeof handleClick === 'function' && handleClick()
        }} 
        target={target}
      >
        <Paragraph
          content={label || title}
          typo={'paragraphLG'}
          weight="medium"
        />
        { description ? (
          <Paragraph
            content={description}
            typo={'paragraphSM'}
          />
        ) : null }
        <S.MenuItemIconWrapper>
          { typeof handleClick === 'function' ? <Icon name="chevron-right" /> : <Icon name="arrow-up-right" /> }
        </S.MenuItemIconWrapper>
      </S.MenuItem>
    </LinkWrapper>
  )
}

export default MenuItem